import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Formik, Form } from 'formik';
import { DndFileUploader } from './DndFileUploader';
import { FileWithPath } from 'react-dropzone/.';
import { InsuranceCertificateFormValues } from '../../types';
import * as yup from "yup";


interface Props {
  commonClasses: any,
  onSubmit: (values: InsuranceCertificateFormValues) => void,
}

export const InsuranceCertificateForm = ({ commonClasses, onSubmit }: Props) => {

  const classes = useStyles();

  const initialValues: InsuranceCertificateFormValues = {
    file: null,
    isConfirmed: false,
    additionalInformation: '',
    name: '',
    title: '',
    signature: '',
  };

  const validationSchema = yup.object({
    file: yup.mixed().required(),
    isConfirmed: yup.boolean().oneOf([true]),
    name: yup.string().required(),
    title: yup.string().required(),
    signature: yup.string().required(),
  });

  return <Formik
    initialValues={initialValues}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ values, handleChange, isValid, errors, touched, dirty, setFieldValue }) => (
      <Form>
        <Typography variant='h5' className={commonClasses.subHeader}>Insurance Certificate</Typography>
        <DndFileUploader onFilesUpload={(uploadedFiles: FileWithPath[]) => setFieldValue('file', uploadedFiles[0] || null)} />

        <FormControl
          required
          error={touched.isConfirmed && Boolean(errors.isConfirmed)}
          sx={{ marginTop: '12px' }}
        >
          <FormControlLabel
            control={
              <Checkbox
                name="isConfirmed"
                value={values.isConfirmed}
                onChange={handleChange}
              />
            }
            label="By checking this box, I confirm that the uploaded certificate of insurance complies with the coverage requirements listed above *"
          />
        </FormControl>

        <Box>
          <Typography variant='h5' className={commonClasses.subHeader}>Additional Information</Typography>
          <TextField
            fullWidth
            name="additionalInformation"
            value={values.additionalInformation}
            onChange={handleChange}
            placeholder="Type here"
            multiline
            rows={2}
          />
        </Box>

        <Box>
          <Typography variant='h5' className={commonClasses.subHeader}>Respondent Signature Section</Typography>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextField
                name="name"
                value={values.name}
                onChange={handleChange}
                fullWidth
                label="Name"
                variant="standard"
                error={touched.name && Boolean(errors.name)}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="title"
                value={values.title}
                onChange={handleChange}
                fullWidth
                label="Title"
                variant="standard"
                error={touched.title && Boolean(errors.title)}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name="signature"
                value={values.signature}
                onChange={handleChange}
                fullWidth
                label="Signature"
                placeholder='Type your name here'
                className={classes.signatureInput}
                error={touched.signature && Boolean(errors.signature)}
                required
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={classes.submitButtonContainer}>
          <Button variant="contained" type="submit" disabled={!isValid || !dirty}>
            Submit
          </Button>
        </Box>
      </Form>
    )}
  </Formik>
};

const useStyles = makeStyles(() => {
  return {
    submitButtonContainer: {
      marginTop: 32,
      display: 'flex',
      justifyContent: 'center'
    },
    signatureInput: {
      '& .MuiInputBase-root': {
        fontFamily: "'Homemade Apple', cursive",
      },
      '& .MuiInputBase-input': {
        lineHeight: '100%',
        textIndent: '12px',
        //paddingBottom: '6px',
      },
    },
  };
});
